import withAbacusTestValuesAsProps from './with-abacus-test-values-as-props';

export default withAbacusTestValuesAsProps;



// WEBPACK FOOTER //
// ./src/universal/abacus/with-abacus-test-values-as-props/index.js